export const ORIGIN_HEADER = 'request-origin';
